module.exports = __webpack_public_path__ + "static/media/10_MEDS-1.9-EC-14 2.90508de1.png";